import React, { useState, useEffect, useRef } from 'react';
import { XText } from "./XText"
import { XDiv } from "./XDiv"

import { useNodes } from './NodeContext'
import { smoothScrollTo } from "../utils/"

import { Tooltip, TooltipRefProps } from 'react-tooltip';
import Nav from 'react-bootstrap/Nav';
import { FaComments, FaEdit, FaInfo, FaBook, FaSearch, FaClipboard, FaLink} from 'react-icons/fa';

import { goToGitHubEdit, copyToClipboard } from '../utils';
import { filter, filterDependencies, sec } from 'mathjs';

import { ToolTipContent } from '../ToolTipContent/ToolTipContent';


export interface MyComponentProps {
  // Define your prop types here
  nodes: []
  number?: number
  id?: string
  startParagraph: number,
  endParagraph: number
}

export const XParagraph: React.FC<MyComponentProps> = (props) => {
  const pRef = useRef<HTMLDivElement>(null);
  const toolTipRef = useRef<TooltipRefProps>(null);
  const [selectedTextRange, setSelectedTextRange] = useState<any | undefined>(undefined) // {start: "", end: ""})
  const [selectedText, setSelectedText] = useState<string>("")
  const [selectedIndices, setSelectedIndices] = useState<string[]>([]);
  const [relatedSelectedIndices, setRelatedSelectedIndices] = useState<any>({});
  const [commentAnnotationIndices, setCommentAnnotationIndices] = useState<any>({});
  const [variantIndexListIndices, setVariantIndexListIndices] = useState<any[]>([]);
  const { data, secondaryData, info, secondaryInfo, handleChangeInfo, handleChangeDictInfo, itemRelatedExpressions, hoverFocus, commentAnnotations, variantIndexList } = useNodes();
  const [relatedTotalCount, setRelatedTotalCount] = useState<number>(0)

  const paraNodes = data?.paraNodes || {}
  const pToDNodesMap = data?.pToDNodesMap || {}

  console.log("selected text", selectedText)

  const shortid: string = props?.id?.split("/resource/")[1] || ""

  const secondaryParaNodes = secondaryData?.paraNodes || {}
  const secondaryParaNode = secondaryParaNodes[shortid] || null

  const isFocus = info.resourceid.includes(props.id) ? true : false
  let style: any = isFocus ? { 'borderLeft': ' 1px dotted green', 'padding': '10px 10px' } : { 'padding': '10px 10px' }
  if (relatedTotalCount) {
    const clampedCount = Math.max(1, Math.min(20, relatedTotalCount)); // Adjust the range as needed
    // Calculate opacity based on a power function
    const opacity = Math.pow(clampedCount / 20, .5); // Adjust the exponent as needed
    style = { ...style, "borderRight": `2px dotted rgba(255, 95, 95, ${opacity})` }
  }



  const paraCount = paraNodes[shortid]?.count || 0

  const scrollToElement = (node = undefined) => {
    const scrollToElementNode = node ? node : pRef.current
    if (scrollToElementNode) {
      smoothScrollTo(scrollToElementNode, 1000); // 1000ms = 1 second
    }
  };


  useEffect(() => {
    //remove all highlighting
    setSelectedIndices([])
    // fire to word range if word range is set
    if (pRef.current && isFocus && info.focusInfo.wordRange?.start && info.focusInfo.wordRange?.end) {
      const indices = getIndexFromWordPosition(info.focusInfo.wordRange.start, info.focusInfo.wordRange.end)
      setSelectedIndices(indices)
      const scrollToElementNode: any = pRef.current.querySelector(`[data-index="${indices[0]}"]`);
      toolTipRef.current?.close()
      scrollToElement(scrollToElementNode)
    }
    // fire to focus element if no  word range it set
    else if (pRef.current && isFocus) {
      scrollToElement();
    }
    else {

    }
  }, [isFocus, info.focusInfo.wordRange?.start, info.focusInfo.wordRange?.end, props.startParagraph, props.endParagraph]);


  useEffect(() => {
    //setRelatedSelectedIndices({})
    //const filteredArray = itemRelatedExpressions.filter((re: any) => { if (re.selectedElementTargetId === shortid) { return re } });
    const filteredArray = variantIndexList.filter((re: any) => { if (re.selectedElementTargetId === shortid) { return re } });
    const filteredNonNullArray = filteredArray.filter(item =>
      item.wordRange.start !== null &&
      item.wordRange.start !== undefined &&
      !Number.isNaN(item.wordRange.start)
    );
    const indicesArray = filteredNonNullArray.map((re) => {
      if (re?.wordRange?.start && re?.wordRange?.end) {
        const indices = getIndexFromWordPosition(re.wordRange.start, re.wordRange.end)
        return indices
      }
    })
    const flattenedArray: any[] = indicesArray.flat();
    // Create an object with counts
    const countObject = flattenedArray.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});

    setVariantIndexListIndices(countObject)
    //setRelatedTotalCount(filteredArray.length)
  //}, [itemRelatedExpressions])
  }, [variantIndexList])

  useEffect(() => {
    //setRelatedSelectedIndices({})
    //const filteredArray = itemRelatedExpressions.filter((re: any) => { if (re.selectedElementTargetId === shortid) { return re } });
    const filteredArray = commentAnnotations.filter((re: any) => { if (re.selectedElementTargetId === shortid) { return re } });
    const filteredNonNullArray = filteredArray.filter(item =>
      item.wordRange.start !== null &&
      item.wordRange.start !== undefined &&
      !Number.isNaN(item.wordRange.start)
    );
    const indicesArray = filteredNonNullArray.map((re) => {
      if (re?.wordRange?.start && re?.wordRange?.end) {
        const indices = getIndexFromWordPosition(re.wordRange.start, re.wordRange.end)
        return indices
      }
    })
    const flattenedArray: any[] = indicesArray.flat();
    // Create an object with counts
    const countObject = flattenedArray.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});

    setCommentAnnotationIndices(countObject)
    //setRelatedTotalCount(filteredArray.length)
  //}, [itemRelatedExpressions])
  }, [commentAnnotations])

  useEffect(() => {
    setRelatedSelectedIndices({})
    const arrayToUse = hoverFocus.length > 0 ? hoverFocus : itemRelatedExpressions
    const filteredArray = arrayToUse.filter((re: any) => { if (re.selectedElementTargetId === shortid) { return re } });
    const filteredNonNullArray = filteredArray.filter(item =>
      item.wordRange.start !== null &&
      item.wordRange.start !== undefined &&
      !Number.isNaN(item.wordRange.start)
    );
    const indicesArray = filteredNonNullArray.map((re) => {
      if (re?.wordRange?.start && re?.wordRange?.end) {
        const indices = getIndexFromWordPosition(re.wordRange.start, re.wordRange.end)
        return indices
      }
    })
    const flattenedArray: any[] = indicesArray.flat();
    // Create an object with counts
    const countObject = flattenedArray.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});

    setRelatedSelectedIndices(countObject)
    setRelatedTotalCount(filteredArray.length)
  }, [itemRelatedExpressions, hoverFocus])

  const getIndexFromWordPosition = (start: number, end: number) => {
    // start from beginning add up lasts
    // find node where last total is less than or equal to start
    // if equal then index is found
    // if last is greater than work back within node to find equal

    const resultIndices: any = []
    const allElements = pRef.current?.querySelectorAll('[data-index]');
    if (allElements) {

      const allIndices: any[] = Array.from(allElements).map(el => el.getAttribute('data-index') || '');
      let runningCount: number = 0
      for (const index of allIndices) {
        runningCount = runningCount + 1
        if (runningCount >= start && runningCount <= end) {
          resultIndices.push(index)
        }
      };
    }
    return resultIndices
  }



  const handleTextSelection = () => {
    const selection = window.getSelection();
    const selectedText = selection ? selection.toString() : '';

    // checking selectedText.length prevents the function from running on any random click within the paragraph. 
    // with the conditional it only runs if there is a selection of one or more characters

    if (selection && selectedText.length > 0 && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const oRect = range.getBoundingClientRect();

      // both conditions here are somewhat hack ways of preventing the tool tip from popping up when the users 
      // selections parts of the paragraph like the tool tip trigger or the text that pops up within the tool tip.
      // TODO: there is probably a better way to do this.
      if (range.startContainer.parentElement?.getAttributeNames().length !== 0) {
        handleShowToolTip(oRect)
      }

      /// Begin possible deletion
      const selectedElements = range.cloneContents().querySelectorAll('[data-index]');
      let indices: any[] = []
      if (selectedElements.length > 0) {

        indices.push(...Array.from(selectedElements).map(el => el.getAttribute('data-index') || ''));
      }
      else if (selectedElements.length === 0) {
        indices.push(range.startContainer?.parentElement?.getAttribute('data-index'))
      }
      /// END possible deletion
      // NOTE/TODO we might not need the above; as this replaced by getIndexFromWordPosition when focus changes
      //setSelectedIndices(indices);

      // begin word count procedure
      const firstIndex = indices[0]
      const lastIndex = indices[indices.length - 1]

      //const startContainer = range.startContainer;
      const allElements = pRef.current?.querySelectorAll('[data-last="true"]');
      if (allElements) {
        const allLastIndices = Array.from(allElements).map(el => el.getAttribute('data-index') || '');

        const reduced: any[] = []

        const normalizeVersion = (version: string): number[] => {
          return version.split('-').map(segment => parseInt(segment, 10));
        };

        const compareVersions = (v1: number[], v2: number[]): number => {
          for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
            const segment1 = v1[i] || 0;
            const segment2 = v2[i] || 0;
            if (segment1 < segment2) return -1;
            if (segment1 > segment2) return 1;
          }
          return 0;
        };

        const numberIndices = allLastIndices.map(normalizeVersion);
        const numberFirstIndex = normalizeVersion(firstIndex);
        const numberLastIndex = normalizeVersion(lastIndex);

        numberIndices.forEach((i) => {
          if (compareVersions(i, numberFirstIndex) < 0) {
            reduced.push(i.join('-'));
          }
        });

        const reducedBeforeLast: any[] = []
        numberIndices.forEach((i) => {
          if (compareVersions(i, numberLastIndex) < 0) {
            reducedBeforeLast.push(i.join('-'));
          }
        });

        const lastNumbers = reduced.map(index => {
          const parts = index.split('-');
          return parseInt(parts[parts.length - 1], 10) + 1;
        });

        const sumOfLastNumbers = lastNumbers.reduce((acc, num) => acc + num, 0);

        const wordCountStart = sumOfLastNumbers + parseInt(firstIndex.split("-")[firstIndex.split("-").length - 1], 10) + 1;

        const lastNumbersBeforeEnd = reducedBeforeLast.map(index => {
          const parts = index.split('-');
          return parseInt(parts[parts.length - 1], 10) + 1;
        });


        const sumOfLastNumbersBeforeEnd = lastNumbersBeforeEnd.reduce((acc, num) => acc + num, 0);
        const wordCountEnd = sumOfLastNumbersBeforeEnd + parseInt(lastIndex.split("-")[lastIndex.split("-").length - 1], 10) + 1;

        setSelectedTextRange({ start: wordCountStart, end: wordCountEnd })
        setSelectedText(selectedText)
      }
    }
  };


  const handleSetFocus = () => {
    const newFocusId = props.id + (info?.focusInfo?.mtFocus || "")
    handleChangeInfo(newFocusId)
  }

  /**
     * @description show tool tip relative to selected text
     * @param {{
        text: string,
        wordRange: object, 
        selectedElementTargetId: string,
      }} selectionRange - object contain needed if about selectedRange
     * @param {object} - coords object resulting from from current selection
     */
  const handleShowToolTip = (selectionCoords: any) => {
    toolTipRef.current?.close()
    toolTipRef.current?.open({
      position: {
        x: (selectionCoords.x + (selectionCoords.width)),
        y: (selectionCoords.y + selectionCoords.height),
      }
    }
    )

  }

  const displayHeading = () => {
    //first make sure the paragraph number is within range
    if (paraCount >= props.startParagraph && paraCount <= props.endParagraph){
      // check to see if para has preceding heading (only goes up one level, so if there were are third it would not be found)
      if (pToDNodesMap[shortid]) {
        return pToDNodesMap[shortid].map((div:any) => {
          const divid = div.divid
          return div.headNodes?.map((node: any) => {
            return (
              <XDiv nodes={node} id={divid}/>
            )
          })
        })
      }
    }
  }

  const displayNormalView = () => {
    return (
      paraCount >= props.startParagraph && paraCount <= props.endParagraph && (
      <div ref={pRef} className="para-div" onMouseUp={handleTextSelection} style={style} onMouseLeave={() => { toolTipRef.current?.close() }}>
        <span className="lbp-span-link" onClick={handleSetFocus}>{paraCount} </span>
        {/* <TextView tresourceid={props.id + "/critical/transcription"}/> */}
        <XText nodes={props.nodes} selectedIndices={selectedIndices} 
        relatedSelectedIndices={relatedSelectedIndices} 
        commentAnnotationIndices={commentAnnotationIndices}
        variantIndexListIndices={variantIndexListIndices}
        index={paraCount} />
        <Tooltip ref={toolTipRef} clickable={true} place="bottom">

        <ToolTipContent 
          handleChangeInfo={handleChangeInfo} 
          handleChangeDictInfo={handleChangeDictInfo}
          id={props.id + (info?.focusInfo?.mtFocus || "")} 
          info={{focusInfo: {mtFocus: "", docSource: props.id + (info?.focusInfo?.mtFocus || ""), expressionid: props.id}}} 
          selectedTextRange={selectedTextRange} 
          selectedText={selectedText}/>


          {/* <Nav>
            <Nav.Link onClick={() => handleChangeInfo(props.id + (info?.focusInfo?.mtFocus || "") + "@" + selectedTextRange.start + '-' + selectedTextRange.end)}><FaInfo /></Nav.Link>
            <Nav.Link><FaComments /></Nav.Link>
            <Nav.Link onClick={() => { goToGitHubEdit(info?.focusInfo.docSource.split("#")[0], selectedText.split(" ")[0] || "", info?.focusInfo?.expressionid.split("/resource/")[1]) }}><FaEdit /></Nav.Link>
            <Nav.Link><FaSearch /></Nav.Link>
            <Nav.Link><FaBook /></Nav.Link>
            <Nav.Link onClick={() => copyToClipboard(props.id + (info?.focusInfo?.mtFocus || "") + "@" + selectedTextRange.start + '-' + selectedTextRange.end)}><FaClipboard /></Nav.Link>

          </Nav> */}
        </Tooltip>
      </div>)
    )
  }

  const displaySecondaryView = () => {
    return (
      paraCount >= props.startParagraph && paraCount <= props.endParagraph && (
      <div>
        <div style={{ "display": "flex", "justifyContent": "space-between", ...style }}>
          <div style={{ paddingRight: "10px", width: "50%" }}>
            <div ref={pRef} className="para-div" onMouseUp={handleTextSelection} onMouseLeave={() => { toolTipRef.current?.close() }}>
              <span className="lbp-span-link" onClick={handleSetFocus}>{paraCount} </span>
              {/* <TextView tresourceid={props.id + "/critical/transcription"}/> */}
              <XText nodes={props.nodes} selectedIndices={selectedIndices} 
              relatedSelectedIndices={relatedSelectedIndices} 
              commentAnnotationIndices={commentAnnotationIndices}
              variantIndexListIndices={variantIndexListIndices}
              index={paraCount} />
              <Tooltip ref={toolTipRef} clickable={true} place="bottom">
                <ToolTipContent 
                  handleChangeInfo={handleChangeInfo} 
                  id={props.id + (info?.focusInfo?.mtFocus || "")} 
                  info={{focusInfo: {mtFocus: "", docSource: props.id + (info?.focusInfo?.mtFocus || ""), expressionid: props.id}}} 
                  selectedTextRange={selectedTextRange} 
                  selectedText={selectedText}/>
                {/* <Nav>
                  <Nav.Link onClick={() => handleChangeInfo(props.id + (info?.focusInfo?.mtFocus || "") + "@" + selectedTextRange.start + '-' + selectedTextRange.end)}><FaInfo /></Nav.Link>
                  <Nav.Link><FaComments /></Nav.Link>
                  <Nav.Link onClick={() => { goToGitHubEdit(info?.focusInfo.docSource.split("#")[0], selectedText.split(" ")[0] || "", info?.focusInfo?.expressionid.split("/resource/")[1]) }}><FaEdit /></Nav.Link>
                  <Nav.Link><FaSearch /></Nav.Link>
                  <Nav.Link><FaBook /></Nav.Link>
                  <Nav.Link onClick={() => copyToClipboard(props.id + (info?.focusInfo?.mtFocus || "") + "@" + selectedTextRange.start + '-' + selectedTextRange.end)}><FaClipboard /></Nav.Link>
                </Nav> */}
              </Tooltip>
            </div>

          </div>
          <div style={{ paddingLeft: "10px", width: "50%", 
          //background: "linear-gradient(to right, white 0%, #e6ede8, white 100%)", // Combined gradients
          }}>
            <div>
              <XText nodes={secondaryParaNode}
                //selectedIndices={selectedIndices} 
                // relatedSelectedIndices={relatedSelectedIndices} 
                index={paraCount}
                ftype="secondary"
              />
            </div>
          </div>
        </div>

      </div>
      )
    )

  }

  return (
    <>
      {displayHeading()}
      {secondaryParaNode ? displaySecondaryView() : displayNormalView()}
    </>
  )
}

